import React, {useEffect} from 'react';
import './about.css';
import ME from '../../assets/port3.JPEG';
import {FaAward} from 'react-icons/fa';
import {FiUsers} from 'react-icons/fi';
import {VscFolderLibrary} from 'react-icons/vsc';
import Aos from 'aos';
import "aos/dist/aos.css";

const About = () => {
  useEffect(() => {
    Aos.init({duration: 1000});
  },[]);

  return (
    <section id="about"> 
      <h5 data-aos="fade-in"> Get to Know me</h5>
      <h2 data-aos="fade-in">  About Me </h2>

      <div className='container about__container'>
        <div className='about__me'>
          <div className='about__me-image'>
            <img src={ME} alt='About me'></img>  
          </div>
        </div>
        <div className='about__content'>
          <div className='about__cards'>
            <article className='about__card' data-aos="zoom-in">
              <FaAward className='about__icon'/>
              <h5> Experience </h5>
              <small> 2+ Years  </small>
            </article>

            <article className='about__card' data-aos="zoom-in">
              <FiUsers className='about__icon'/>
              <h5> Clients </h5>
              <small> 2 </small>
            </article>

            <article className='about__card' data-aos="zoom-in">
              <VscFolderLibrary className='about__icon'/>
              <h5> Projects </h5>
              <small> 5+ completed </small>
            </article>
          </div>

          <p data-aos="zoom-in">
            Hey there, I am Elton! I am a web developer and a UI/UX designer.
            In a nutshell, I develop and design websites that can help organizations and private business owners
            address business challenges and meet their needs. My expertise lies within front-end web applications,
            and the main languages in my tech stark are JavaScript, React and Next JS,  WordPress and of course HTML/CSS. I am quietly confident,
            naturally curious and perpetually working on improving my chops one project at a time.
          </p>

          <a href="#contact" className="btn btn-primary" data-aos="fade-in"> Let's Talk </a>
        </div>
      </div>
    </section>
  )
}

export default About